<template>
    <div>
        <v-btn
            v-if="value && value.length"
            v-bind="$attrs"
            text
            class="px-0"
            :href="hrefValue"
            :target="linkTarget"
        >
            <v-icon v-if="prependIcon && displayValue" class="mr-1">{{
                prependIcon
            }}</v-icon>
            <span>{{ displayValue }}</span>
            <v-icon v-if="appendIcon && displayValue" class="ml-1">{{
                appendIcon
            }}</v-icon>
        </v-btn>
        <span v-else></span>
    </div>
</template>

<script>
import { isUrl } from '@/common/helpers';

export default {
    name: 'ActionLinkButton',
    props: {
        value: {
            type: String,
            required: false,
            default: ''
        },
        linkType: {
            type: String,
            required: false,
            validator: value => ['mailto', 'tel', ''].includes(value),
            default: ''
        },
        linkTarget: {
            type: String,
            required: false,
            default: ''
        },
        appendIcon: {
            type: String,
            required: false,
            default: ''
        },
        prependIcon: {
            type: String,
            required: false,
            default: ''
        }
    },
    computed: {
        displayValue() {
            if (this.linkType === 'mailto') {
                return this.value;
            } else if (this.linkType === 'tel') {
                return this.formatPhoneNumber(this.value);
            } else {
                return this.formatUrl(this.value);
            }
        },
        hrefValue() {
            if (this.linkType === 'mailto') {
                return `mailto:${this.value}`;
            } else if (this.linkType === 'tel') {
                return `tel:${this.parsePhone(this.value)}`;
            } else {
                return this.value;
            }
        }
    },
    methods: {
        formatUrl(value) {
            if (value && isUrl(value)) {
                const url = new URL(value);
                return url.hostname;
            }
            return value;
        },
        formatPhoneNumber(phoneNumberString) {
            const cleaned = ('' + phoneNumberString).replace(/\D/g, '');
            const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
            if (match) {
                return '(' + match[1] + ') ' + match[2] + '-' + match[3];
            }
            return phoneNumberString;
        },
        parsePhone(value) {
            const phoneMask = /[()\-+\s]/g;
            if (value) {
                let rawValue = String(value);
                if (phoneMask.test(value)) {
                    rawValue = value.replace(phoneMask, '');
                }
                if (rawValue && rawValue.length <= 10) {
                    return `+1${rawValue}`;
                }
                return `+${rawValue}`;
            }
            return '';
        }
    }
};
</script>

<style></style>
